import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { provideNzI18n, it_IT, NZ_DATE_CONFIG } from 'ng-zorro-antd/i18n';
import { provideNzConfig } from 'ng-zorro-antd/core/config';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';
import { routes } from './app.routes';

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withXhr()),
    { provide: LOCALE_ID, useValue: 'it' },
    provideNzI18n(it_IT),
    { provide: NZ_DATE_CONFIG, useValue: { firstDayOfWeek: 1 } },
    provideNzConfig({ icon: { nzTheme: 'outline' } }),
    provideNzDateFnsAdapter(),
  ],
};
